import { render, staticRenderFns } from "./timelimit-seckill.vue?vue&type=template&id=0122be1e&scoped=true&"
import script from "./timelimit-seckill.vue?vue&type=script&lang=js&"
export * from "./timelimit-seckill.vue?vue&type=script&lang=js&"
import style0 from "./timelimit-seckill.vue?vue&type=style&index=0&id=0122be1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0122be1e",
  null
  
)

export default component.exports